import React from "react";
import "./App.css";

const whatsappLink = "https://wa.me/5511930900960";

const services = [
  {
  title: "Fechamento de sacadas",
  text: "Soluções modernas que garantem conforto térmico, acústico e valorização estética do ambiente."
},
{
  title: "Espelhos sob medida",
  text: "Espelhos personalizados com acabamento preciso, ampliando espaços com elegância e sofisticação."
},
{
  title: "Box para banheiro",
  text: "Box em vidro temperado com ferragens de alta durabilidade, segurança e design contemporâneo."
},
{
  title: "Portas e janelas em vidro",
  text: "Sistemas em vidro que unem luminosidade, isolamento e alta performance estrutural."
},
{
  title: "Guarda-corpos",
  text: "Proteção com transparência e design, utilizando vidros de segurança e fixações de alto padrão."
},

];

const projects = [
  {
    name: "Box de vidro",
    detail: "Box de qualidade.",
    image: "/portifolio/IMG_20240917_154141.jpg",
  },
  {
    name: "Espelhos personalizados",
    detail: "Sua criatividade resumida a qualidade.",
    image:
      "/portifolio/Screenshot_2025-09-18-19-12-58-045_com.google.android.apps.photos-edit.jpg",
  },
  {
    name: "Porta divisão de ambientes",
    detail: "Trilho slim no piso para passagem sem tropeço, vidro com tratamento avisado.",
    image:
      "/portifolio/Screenshot_2025-11-26-18-14-36-311_com.google.android.apps.photos.jpg",
  },
];

const process = [
  {
    step: "01",
    title: "Briefing",
    text: "Entendimento do projeto, uso do ambiente e expectativas estéticas.",
  },
  {
    step: "02",
    title: "Engenharia",
    text: "Especificacoes tecnicas, orcamento e cronograma detalhado.",
  },
  {
    step: "03",
    title: "Producao",
    text: "Fabricacao precisa, inspecao e preparo para instalacao.",
  },
  {
    step: "04",
    title: "Entrega",
    text: "Instalacao limpa, alinhamento final e pos-obra dedicada.",
  },
];

function App() {
  return (
    <div className="page">
      <header className="hero-wrap">
        <nav className="nav">
          <div className="logo">
            <img src="/logo/vidralumi_logo.jpg" alt="Logo Vidralumi" />
            <div>
              <span className="logo-name">Vidralumi</span>
              <span className="logo-tag">Vidros e Solucoes</span>
            </div>
          </div>

          <div className="nav-actions">
            <a className="button ghost" href="#projects">
              Ver Projetos
            </a>
            <a className="button primary" href={whatsappLink}>
              Solicitar Orcamento
            </a>
          </div>
        </nav>

        <section className="hero">
          <div className="hero-copy">
            <span className="eyebrow">Vidros e Alumínio</span>
            <h1>Transparência, Tecnologia e Excelência em Cada Detalhe.</h1>
            <div className="hero-actions">
            </div>
            <p>
              Na Vidralumi, transformamos vidro em sofisticação, segurança e conforto. Somos especialistas em soluções de alto padrão para residências e empresas, unindo tecnologia de ponta, materiais de qualidade superior e um acabamento impecável.
            </p>
            <div className="hero-actions">
            </div>
            <div className="hero-badges">
              <div>
                <strong>+xxxx</strong>
                <span>Projetos entregues</span>
              </div>
              <div>
                <strong>xx anos</strong>
                <span>de experiência</span>
              </div>
              <div>
                <strong>Qualidade</strong>
                <span>atendimento qualificado</span>
              </div>
              <div>
                <strong>Segurança</strong>
                <span>em todo o processo</span>
              </div>
            </div>
          </div>
        </section>
      </header>

      <main>
        <section id="services" className="section">
          <div className="section-header">
              <span className="eyebrow">Soluções</span>
          </div>
          <div className="grid-4">
            {services.map((service) => (
              <article className="card" key={service.title}>
                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </article>
            ))}
          </div>
        </section>
        <br/>
        <br/>
        <section id="projects" className="section">
          <div className="section-header">
            <div>
              <span className="eyebrow">Projetos</span>
              <h2>Vidralumi. Onde qualidade e tecnologia se encontram para iluminar seus ambientes.</h2>
            </div>
            <p>
              Mais do que instalar vidro, entregamos tranquilidade, valorização do seu espaço e soluções inteligentes que aliam design e inovação.
            </p>
          </div>
          <div className="project-grid">
            {projects.map((project) => (
              <article className="project" key={project.name}>
                <img
                  className="project-image"
                  src={project.image}
                  alt={`Projeto ${project.name}`}
                />
                <div className="project-body">
                  <h3>{project.name}</h3>
                  <p>{project.detail}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        
        <br/>
        <section id="contact" className="section cta">
          <div>
            <span className="eyebrow">Vamos conversar</span>
            <h2>Pronto para transformar o seu projeto em vidro?</h2>
            <p>
              Envie detalhes da obra e receba uma proposta personalizada com
              prazo e especificações técnicas.
            </p>
          </div>
          <div className="cta-actions">
            <a className="button primary" href={whatsappLink}>
              Solicitar Orcamento
            </a>
            <a 
            href="https://www.instagram.com/vidralumi.tec/"
              target="_blank"
              rel="noreferrer"
              className="button ghost" >
              Ver Portfolio
            </a>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-brand">
          <div className="logo">
            <img src="/logo/vidralumi_logo.jpg" alt="Logo Vidralumi" />
            <div>
              <span className="logo-name">Vidralumi</span>
              <span className="logo-tag">Soluções em Vidraçaria</span>
            </div>
          </div>
          <p>
            Av. Sinésio Pereira - Campanário, Diadema - SP. 
            <br/>
            Atendimento especializado em
            vidros sob medida.
          </p>
        </div>
        <div className="footer-links">
          <div>
            <strong>Contato</strong>
            <a href="tel:+5511930900960">+55 (11) 93090-0960</a>
            <a href="mailto:contato@vidralumi.com">contato@vidralumi.com</a>
            <a
              href="https://www.instagram.com/vidralumi.tec/"
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>
          </div>
          <div>
            <strong>Serviços</strong>
            <span>Fachadas de vidro</span>
            <span>Fechamento de sacadas</span>
            <span>Espelhos sob medida</span>
            <span>Box premium</span>
          </div>
          <div>
            <strong>Atendimento</strong>
            <span>Segunda a sexta, 08h as 18h</span>
            <span>Visitas tecnicas agendadas</span>
            <a href={whatsappLink}>WhatsApp direto</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
